import { taggedTemplateLiteral as _taggedTemplateLiteral, objectWithoutProperties as _objectWithoutProperties, slicedToArray as _slicedToArray, extends as _extends } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import styled from '../../theming/styled-components.js';
import themes from '../../theming/themes.js';
import React, { memo } from 'react';
import withDefaultTheme from '../../hocs/withDefaultTheme.js';
import { transparentize } from 'polished';
import useDebounce from '../../hooks/useDebounce.js';
import _Spinner from '../Spinner/index.js';

var _excluded = ["isShown", "loadingText", "theme", "language", "size", "children", "viewportCentered"];
var _templateObject, _templateObject2;
var StyledOverlay = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  position: absolute;\n\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n\n  background-color: ", ";\n  z-index: 150;\n"])), function (_ref) {
  var palette = _ref.theme.palette;
  return transparentize(0.2, palette.white);
});
var StyledIconContainer = styled.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  position: ", ";\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  z-index: 151;\n"])), function (_ref2) {
  var viewportCentered = _ref2.viewportCentered;
  return viewportCentered ? 'fixed' : 'absolute';
});
var Loader = function Loader(_ref3) {
  var _ref3$isShown = _ref3.isShown,
    isShown = _ref3$isShown === void 0 ? false : _ref3$isShown,
    loadingText = _ref3.loadingText,
    _ref3$theme = _ref3.theme,
    theme = _ref3$theme === void 0 ? themes["default"] : _ref3$theme,
    _ref3$language = _ref3.language,
    language = _ref3$language === void 0 ? 'en' : _ref3$language,
    _ref3$size = _ref3.size,
    size = _ref3$size === void 0 ? 'large' : _ref3$size,
    children = _ref3.children,
    _ref3$viewportCentere = _ref3.viewportCentered,
    viewportCentered = _ref3$viewportCentere === void 0 ? false : _ref3$viewportCentere,
    rest = _objectWithoutProperties(_ref3, _excluded);
  var _useDebounce = useDebounce(isShown, 250),
    _useDebounce2 = _slicedToArray(_useDebounce, 1),
    debouncedIsShown = _useDebounce2[0];
  return /*#__PURE__*/React.createElement("div", {
    style: {
      position: 'relative'
    }
  }, debouncedIsShown && /*#__PURE__*/React.createElement(StyledOverlay, _extends({
    "data-testid": 'loader-overlay'
  }, rest, {
    theme: theme
  }), /*#__PURE__*/React.createElement(StyledIconContainer, {
    viewportCentered: viewportCentered
  }, /*#__PURE__*/React.createElement(_Spinner, {
    isShown: debouncedIsShown,
    loadingText: loadingText,
    theme: theme,
    language: language,
    size: size
  }))), children);
};
var _Loader = withDefaultTheme(/*#__PURE__*/memo(Loader));

export default _Loader;
